import React from 'react'
import { rxGamepadButtons, rxGamepadAxes } from '../lib/rx_subject'

const Gamepad = () => {
  const requestId = React.useRef(null)

  const checkPad = React.useCallback(() => {
    const pads = navigator.getGamepads()
    for (let i = 0; i < pads.length; i++) {
      const pad = pads[i]
      if (pad) {
        for (let j = 0; j < rxGamepadButtons.length; j++) {
          rxGamepadButtons[j].next(pad.buttons[j].pressed)
        }
        for (let j = 0; j < rxGamepadAxes.length; j++) {
          rxGamepadAxes[j].next(pad.axes[j])
        }
      }
    }
    requestId.current = requestAnimationFrame(checkPad)
  }, [])

  React.useEffect(() => {
    requestId.current = requestAnimationFrame(checkPad)

    return () => {
      cancelAnimationFrame(requestId)
    }
  }, [checkPad])

  return (
    <div />
  )
}

export default Gamepad
